<template>
  <div class="floating">
    <draggable
      class="list"
      v-if="!!list.length"
      :value="list"
      v-bind="dragOptions"
      :activeLinkId="activeLinkId"
      @input="onDragInput"
      @start="drag = true"
      @end="drag = false">
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div class="item"
          v-for="item in list"
          :activeLinkId="activeLinkId"
          :key="item.id">
          <span class="icon"
            :class="{active: item.icon}"
            :style="iconStyle">
            <img v-if="item.icon"
            :src="item.icon"
            alt="" />
            <label class="upload"
              :for="item.id">
              <input type="file" :id="item.id" @change="uploadIcon(item, $event)">i
            </label>
            <button v-if="item.icon" type="button" class="btnDel" @click="delIcon(item)"><span class="blind">remove</span></button>
          </span>
          <span class="icon"
            v-if="item.icon"
            :class="{active: item.activeIcon}"
            :style="iconActiveStyle">
            <span class="stkr">{{ locale.activate }}</span>
            <img v-if="item.activeIcon"
            :src="item.activeIcon"
            alt="" />
            <label class="upload"
              :for="`${item.id}_active`">
              <input type="file" :id="`${item.id}_active`" @change="uploadActiveIcon(item, $event)">i
            </label>
            <button v-if="item.activeIcon" type="button" class="btnDel" @click="delActiveIcon(item)"><span class="blind">remove</span></button>
          </span>
          <div class="editItem">
            <button type="button" title="edit menu link" :class="{btnEditLink: true, hasLink: hasLink(item), active: isActive(item)}" @click.stop="editLink(item, $event)">
              <img src="~@/assets/img/ico_link.svg" alt="">
            </button>
            <button type="button" class="btnRemove" title="remove item" @click.stop="removeItem(item)"><img src="~@/assets/img/ico_minus.svg" alt=""></button>
          </div>
        </div>
      </transition-group>
    </draggable>
    <button v-show="list.length < 3" class="btn btnWhite btnFull btnAdd" @click.stop="addItem">+</button>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import draggable from 'vuedraggable'
import lang from '@/common/lang'

export default {
  name: 'FloatingList',
  components: {
    draggable
  },
  props: [
    'locale',
    'activeLinkId',
    'list',
    'bannerStyle',
    'bannerActiveStyle'
  ],
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    iconStyle () {
      const style = this.bannerStyle || {}
      const axisY = style.axisY
      const axis = axisY ? 'height' : 'width'
      return {
        [axis]: `${style.size || 60}px`
      }
    },
     iconActiveStyle () {
      const style = this.bannerActiveStyle || {}
      const axisY = style.axisY
      const axis = axisY ? 'height' : 'width'
      return {
        [axis]: `${style.size || 60}px`
      }
    }
  },
  data () {
    return {
      drag: false
    }
  },
  methods: {
    addItem () {
      const langValue = this.$store.getters['setting/getLangValues']()
      const defaultItem = {
        id: UNIQUE.mid(),
        icon: '',
        activeIcon: '',
        target: false,
        type: 'outlink',
        url: Object.assign({}, langValue),
        pageId: ''
      }
      this.$emit('updateList', [...this.list, defaultItem])
    },
    removeItem (item) {
      if (window.confirm(this.locale.confirm_delete_floating)) {
        const nextList = this.list.filter(x => x.id !== item.id)
        this.$emit('updateList', nextList)
      }
    },
    updateItemById (id, data) {
      const nextList = this.list.map(item =>
        item.id === id
          ? { ...item, ...data }
          : item
      )
      this.$emit('updateList', nextList)
    },
    uploadIcon (item, e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())

      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.updateItemById(item.id, {
            icon: res.source
          })
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delIcon (item) {
      if (window.confirm(this.locale.confirm_delete_icon)) {
        this.updateItemById(item.id, {
          icon: ''
        })
      }
    },
    uploadActiveIcon (item, e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())

      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.updateItemById(item.id, {
            activeIcon: res.source
          })
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delActiveIcon (item) {
      if (window.confirm(this.locale.confirm_delete_icon)) {
        this.updateItemById(item.id, {
          activeIcon: ''
        })
      }
    },
    editLink (item) {
      this.$emit('setMode', 'link')
      this.$emit('setEditLink', item)
    },
    isActive (item) {
      const result = item.id === this.activeLinkId
      return result
    },
    hasLink (item) {
      const result = (item.type === 'page' && item.pageId) ||
                     (item.type === 'outlink' && Object.keys(item.url).filter(x => item.url[x].trim() === '').length === 0) ||
                     (item.type === 'shortcut' && typeof (item.shortcutId) !== 'undefined') ||
                     (item.type.includes('interlock') && typeof (item.interlockId) !== 'undefined')
      return result
    },
    onDragInput (nextList) {
      this.$emit('updateList', nextList)
    }
  }
}
</script>

<style lang="scss" scoped>
.floating {
  .item {
    display: flex;
    align-items: center;
    padding: 15px;
    margin-bottom: 15px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
  }
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 62px;
    margin-right: 20px;
    border-radius: 2px;
    border: 1px dashed $color-lgrey;
    background-color: $bg-default;
    &[style*="height"] {
      width: auto;
    }
    &.active {
      background-color: transparent;
      .upload {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
    img {
      max-height: 100%;
    }
    .upload {
      display: block;
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      opacity: 0.5;
      cursor: pointer;
    }
    .btnDel {
      position: absolute;
      top: -10px;
      left: 100%;
      width: 16px;
      height: 16px;
      margin-left: -4px;
      border-radius: 100%;
      background: $color-dark url('~@/assets/img/ico_close.svg') 50% 50% / 8px no-repeat;
    }
    .stkr {
      position: absolute;
      left: 0;
      bottom: 100%;
      padding: 2px 8px;
      font-size: 11px;
      line-height: 1;
      color: $color-white;
      border-radius: 4px 4px 0 0;
      background-color: $color-primary;
    }
  }
  .editItem {
    display: flex;
    margin-left: auto;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      width: 30px;
      height: 30px;
      opacity: 0.2;
      &.active {
        background-color: $bg-default;
        box-shadow: 0 0 1px $color-lgrey, inset 0 0 4px rgba($color-lgrey, 0.4);
        opacity: 0.5;
      }
      &:hover {
        opacity: 1;
      }
      &.hasLink {
        opacity: 1;
      }
      img {
        width: 16px;
      }
    }
  }
  .btnAdd {
    margin-top: 15px;
    padding-top: 0.3em;
    padding-bottom: 0.3em;
    font-size: 1.6em;
  }
}
</style>
